import axios from '../../utils/axios.js'

export const findDevices = (query) => axios.setAxiosPostPromise('device/findDevices', query)

export const findByQuery = (query) => axios.setAxiosPostPromise('device/findByQuery', query)

export const add = (options) => axios.setAxiosPostPromise('device/add', options)

export const updateBySn = (query, options) => axios.setAxiosPutPromise(`device/updateBySn/${query}`, options)

export const updateMany = (options) => axios.setAxiosPostPromise(`device/updateMany`, options)

export const deleteBySn = (query) => axios.setAxiosDeletePromise(`device/deleteBySn/${query.sn}`, query)

export const findAll = (query) => axios.setAxiosGetPromise('device/findAll', query)

export const importDevice = (options) => axios.upload('device/importDevice', options)

// 下载导入失败信息文件
export const downloadFile = (query) => axios.setAxiosGetPromise('file/download', query)

// 创建导出任务
export const exportDevice = (options) => axios.setAxiosPostPromise('device/exportDevice', options)

export const reset = (query) => axios.setAxiosGetPromise('device/reset', query)

export const findDevicelogs = (query) => axios.setAxiosGetPromise('device/findDevicelogs', query)



// WEBPACK FOOTER //
// ./src/services/system/device.js